module.exports = __webpack_public_path__ + "img/notification.34e3c659.svg";